import {KinesisEvent} from "../kinesis.event";
import {KINESIS} from "../../kinesis.consts";

export class SignInDisplayKinesisEvent extends KinesisEvent {
  constructor() {
    super(
      KINESIS.CATEGORY.bolao,
      KINESIS.ACTION.signIn,
      KINESIS.LABEL.display,
      null
    );
  }
}
